import React from 'react';
import { Form } from 'react-bootstrap';
import CreatableSelect from 'react-select/creatable';
import { IoMdClose } from 'react-icons/io';

const ChargesSection = ({
  additionalCharges,
  chargeOptions,
  productsTotal,
  additionalChargesTotal,
  grossTotal,
  grandTotal,
  onChargeChange,
  onAddCharge,
  onRemoveCharge
}) => {
  return (
    <div className="card mt-4">
      <div className="card-header bg-light">
        <strong>Summary & Charges</strong>
      </div>
      <div className="card-body">
        {/* Products Total */}
        <div className="d-flex justify-content-between align-items-center mb-3">
          <div className="fw-bold">Products Total:</div>
          <div className="fw-bold fs-6">₹{productsTotal.toFixed(2)}</div>
        </div>

        {/* Charges Header */}
        <div className="row g-2 mb-2 fw-bold border-bottom pb-2">
          <div className="col-md-4">Charge Type</div>
          <div className="col-md-2">Charge %</div>
          <div className="col-md-2">Amount (₹)</div>
          <div className="col-md-2">GST %</div>
          <div className="col-md-2 text-end">Total (₹)</div>
        </div>

        {/* Charges List */}
        {additionalCharges.map((charge, index) => (
          <ChargeRow
            key={charge.id}
            charge={charge}
            index={index}
            chargeOptions={chargeOptions}
            onChargeChange={onChargeChange}
            onRemoveCharge={onRemoveCharge}
            isFirst={index === 0}
            totalCharges={additionalCharges.length}
          />
        ))}

        {/* Additional Charges Total */}
        <div className="d-flex justify-content-between align-items-center mb-3 border-top pt-2">
          <div className="fw-bold">Additional Charges Total:</div>
          <div className="fw-bold fs-6">
            ₹{additionalChargesTotal.toFixed(2)}
          </div>
        </div>

        {/* Gross Total */}
        <div className="d-flex justify-content-between align-items-center mb-3 border-top pt-2">
          <div className="fw-bold">Gross Total:</div>
          <div className="fw-bold fs-6">₹{grossTotal.toFixed(2)}</div>
        </div>

        {/* Add Charge Button */}
        <div className="text-end mt-2">
          <button
            type="button"
            className="button-70 btn-success"
            onClick={onAddCharge}
          >
            + Add New Charge
          </button>
        </div>

        {/* Rounded Grand Total */}
        <div className="d-flex justify-content-between align-items-center mt-3 pt-2 border-top">
          <div className="fw-bold fs-5">Grand Total (Rounded):</div>
          <div className="fw-bold fs-5 text-primary">
            ₹{grandTotal.toFixed(2)}
          </div>
        </div>
      </div>
    </div>
  );
};

const ChargeRow = ({
  charge,
  index,
  chargeOptions,
  onChargeChange,
  onRemoveCharge,
  isFirst,
  totalCharges
}) => {
  const gstAmount = (charge.amount * charge.gstPercent) / 100;
  const totalAmount = charge.amount + gstAmount;

  // ✅ New charge type add karne ka handler
  const handleCreateOption = (inputValue) => {
    const newOption = { value: inputValue, label: inputValue };
    chargeOptions.push(newOption); // runtime me list me add kar rahe hain
    onChargeChange(index, "description", inputValue);
  };

  return (
    <div className="row g-2 mb-3 align-items-center">
      {/* Charge Type Select */}
      <div className="col-md-4">
        <CreatableSelect
          value={chargeOptions.find(opt => opt.value === charge.description) || null}
          onChange={(val) => onChargeChange(index, "description", val?.value || "")}
          onCreateOption={handleCreateOption}
          options={chargeOptions}
          placeholder="Select or type new charge"
          menuPortalTarget={document.body}
          styles={{
            menuPortal: base => ({ ...base, zIndex: 9999 })
          }}
        />
      </div>

      {/* Charge % Field */}
      <div className="col-md-2">
        <Form.Control
          type="number"  
          max="100"
          value={charge.chargepercent || ""}
          onChange={(e) => {
            let val = parseFloat(e.target.value) || 0;
            if (val > 100) val = 100;
            onChargeChange(index, "chargepercent", val, false);
          }}
          onBlur={(e) => {
            let val = parseFloat(e.target.value) || 0;
            if (val > 100) val = 100;
            onChargeChange(index, "chargepercent", val, true);
          }}
          disabled={charge.amount > 0}
        />
      </div>

      {/* Amount (₹) Field */}
      <div className="col-md-2">
        <Form.Control
          type="number"
          step="0.01"
          value={charge.amount || ""}
          onChange={(e) => {
            const val = parseFloat(e.target.value) || 0;
            onChargeChange(index, "amount", val);
          }}
          disabled={charge.chargepercent > 0}
        />
      </div>

      {/* GST % Field */}
      <div className="col-md-2">
        <Form.Control
        className='gst'
          type="number"
          value={charge.gstPercent}
          onChange={(e) =>
            onChargeChange(index, "gstPercent", parseFloat(e.target.value) || 0)
          }
        />
      </div>

      {/* Total Amount Display */}
      <div className="col-md-2 text-end">
        ₹{totalAmount.toFixed(2)}
      </div>

      {/* Remove Button */}
      <div className="col-md-2 text-center">
        <button
          className="button-70 btn-danger"
          onClick={() => onRemoveCharge(index)}
          disabled={totalCharges <= 1}
        >
          <IoMdClose />
        </button>
      </div>
    </div>
  );
};

export default ChargesSection;